// extracted by mini-css-extract-plugin
export default {"startButton":"Question_startButton__3Ufgb","question":"Question_question__KGlm0","radio":"Question_radio__fWHzN","label":"Question_label__tbpam"};